<template>
  <fn-slider
    class="brand-alpha-index-slider"
    navigation-outside-container="alpha-index"
    :options="{
      slidesPerView: 'auto',
      spaceBetween: 10,
      pagination: false,
      navigation: true,
    }"
  >
    <fn-slide>
      <div
        class="bais-item"
        :class="{
          'bais-item--active': showAll,
        }"
        @click="$emit('resetFilter')"
      >
        {{ $t('buttons.showAll') }}
      </div>
    </fn-slide>
    <fn-slide
      v-for="(value, name, index) in items"
      v-show="value.length > 0"
      :key="index"
    >
      <div
        class="bais-item"
        :class="{
          'bais-item--active': !showAll && activeItemName === name,
        }"
        @click="$emit('filterBrands', name)"
      >
        {{ name === 'other' ? '#' : name.toUpperCase() }}
      </div>
    </fn-slide>
  </fn-slider>
</template>

<script>
export default defineComponent({
  props: {
    items: {
      type: Object,
      required: true,
    },
    activeItemName: {
      type: String,
      default: '',
    },
    showAll: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['filterBrands', 'resetFilter'],
});
</script>

<style lang="scss" scoped>
.brand-alpha-index-slider {
  .bais-item {
    cursor: pointer;
    background: $color-general-background-neutral-default;
    padding: $pad - 4px $pad;
    border-radius: map-get($border-radiuses, 'l');
    line-height: 1;
    border: 1px solid palette(sand);
    font-size: map-get($font-sizes, 'm');

    &.bais-item--active {
      background: $color-brand-fnmz-green;
      border-color: $color-brand-fnmz-green;
      color: $color-general-text-inverse-default;
    }
  }

  :deep(.swiper-button-prev),
  :deep(.swiper-button-next) {
    top: calc(50% - 24px);
  }
}
</style>
